<template>
  <div class="items main-content">
    <div class="page-header">
      <div class="d-flex flex-row">
        <div>
          <h3 class="page-title">{{ $tc('emails.dynamic_templates') }}</h3>
        </div>
      </div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#"> {{ $tc('emails.dynamic_templates') }}</router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <a class="col-xs-2" href="#" @click="dynamicTemplateModal">
          <base-button
            color="theme"
            icon="plus"
            size="large"
          >
            {{ $t('emails.create_dynamic_template') }}
          </base-button>
        </a>
      </div>
    </div>
    <div v-cloak v-show="showEmptyScreen" class="col-xs-1 no-data-info" align="center">
      <satellite-icon class="mt-5 mb-4"/>
      <div class="row" align="center">
        <label class="col title">{{ $t('emails.no_dynamic_template') }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{ $t('emails.list_of_dynamic_template') }}</label>
      </div>
      <div class="btn-container">
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="dynamicTemplateModal"
        >
          {{ $t('emails.add_new_dynamic_template') }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ templates.length }}</b> {{ $t('general.of') }} <b>{{ templates.length }}</b></p>
      </div>
      <table-component
        ref="table"
        :data="templates"
        :show-filter="false"
        table-class="table"
      >
        <table-column
          :label="$t('emails.template_name')"
          show="name"
        />
        <table-column
          :label="$tc('emails.action_type',1)"
          show="action"
        />
        <table-column
          :label="$t('emails.updated_at')"
          show="updated_at"
        />

        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <router-link :to="{path: `emailTemplates/${row.id}/edit`}" class="dropdown-item">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                  {{ $t('general.edit') }}
                </router-link>
              </v-dropdown-item>
              <v-dropdown-item>
                <div class="dropdown-item" @click="removeTemplate(row.id)">
                  <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                  {{ $t('general.delete') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DotIcon from '../../components/icon/DotIcon'
import SatelliteIcon from '../../components/icon/SatelliteIcon'
import BaseButton from '../../../js/components/base/BaseButton'

export default {
  components: {
    DotIcon,
    SatelliteIcon,
    BaseButton
  },
  data () {
    return {
      id: null,
      showFilters: false,
      isRequestOngoing: true,
      filtersApplied: false
    }
  },

  computed: {
    ...mapGetters('emailTemplates', [
      'templates'
    ]),
    showEmptyScreen () {
      return !this.templates && !this.isRequestOngoing && !this.filtersApplied
    },
    filterIcon () {
      return (this.showFilters) ? 'times' : 'filter'
    }
  },

  watch: {
    filters: {
      handler: 'setFilters',
      deep: true
    }
  },
  created () {
    this.fetchData()
  },
  destroyed () {
    if (this.selectAllField) {
      this.selectAllCommunications()
    }
  },
  methods: {
    ...mapActions('emailTemplates', [
      'fetchDynamicTemplates',
      'deleteEmailTemplate'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    refreshTable () {
      this.$refs.table.refresh()
    },
    async fetchData () {
      this.isRequestOngoing = true
      let response = await this.fetchDynamicTemplates()
      this.isRequestOngoing = false

      if (response.data && response.data.success === true) {
        return response.data.data.templates
      }
    },
    setFilters () {
      this.filtersApplied = true
      this.refreshTable()
    },
    clearFilter () {
      this.filters = {
        name: '',
        part_number: '',
        unit: '',
        price: ''
      }

      this.$nextTick(() => {
        this.filtersApplied = false
      })
    },
    toggleFilter () {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter()
        this.refreshTable()
      }
      this.showFilters = !this.showFilters
    },
    dynamicTemplateModal () {
      this.$router.push(`/super-admin/emailTemplates/create`)
      // this.openModal({
      //   'title': this.$t('emails.template_name'),
      //   'componentName': 'DynamicTemplateModal'
      // })
      // this.$refs.table.refresh()
    },
    async removeTemplate (id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('emails.confirm_delete_template'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.deleteEmailTemplate(id)
          if (res.data.success) {
            window.toastr['success'](this.$tc('emails.template_deleted_message'))
            this.fetchData()
            return true
          }
        }
      })
    }
  }
}
</script>
